import * as React from 'react';
import { useState } from 'react';

import GroupsDeprecationModal from 'bundles/admin-v2/components/GroupsDeprecationModal';
import LoggedInAdminDesktopMainNav from 'bundles/composable-page-header-admin/main-nav-modules/desktop/LoggedInAdminDesktopMainNav';
import LoggedInAdminMobileMainNav from 'bundles/composable-page-header-admin/main-nav-modules/mobile/LoggedInAdminMobileMainNav';
import AdminPageHeaderProvider from 'bundles/composable-page-header-admin/providers/AdminPageHeaderProvider';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

type Props = {
  handleGroupsClick: () => void;
};

const AdminPageHeader = ({ handleGroupsClick }: Props) => {
  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<LoggedInAdminDesktopMainNav handleGroupsClick={handleGroupsClick} />}
      mobileMainNav={<LoggedInAdminMobileMainNav />}
    />
  );
};

const AdminPageHeaderWithProvider = () => {
  const [isGroupsModalOpen, setIsGroupsModalOpen] = useState(false);
  const handleGroupsClick = () => setIsGroupsModalOpen(true);
  const closeGroupsModal = () => setIsGroupsModalOpen(false);

  return (
    <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={undefined}>
      <AdminPageHeaderProvider>
        <AdminPageHeader handleGroupsClick={handleGroupsClick} />
        {isGroupsModalOpen && <GroupsDeprecationModal onClose={closeGroupsModal} />}
      </AdminPageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
};

export default AdminPageHeaderWithProvider;
